import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'

export default {
  h1: () => i18n.t(i18nKeys.startedSigningUpModal__h1),
  h1Existing: () =>
    i18n.t(i18nKeys.startedSigningUpModal__h1__existingApplicant),
  h1LoggedIn: () => i18n.t(i18nKeys.startedSigningUpModal__h1__loggedIn),
  description: () => i18n.t(i18nKeys.startedSigningUpModal__description),
  descriptionExisting: () =>
    i18n.t(i18nKeys.startedSigningUpModal__description__existingApplicant),
  descriptionLoggedIn: () =>
    i18n.t(i18nKeys.startedSigningUpModal__description__loggedIn),
  email: () => i18n.t(i18nKeys.common__email),
  phone: () => i18n.t(i18nKeys.common__phone),
  continue: () => i18n.t(i18nKeys.common__continue),
  resumeApplicationPrimaryAction: () =>
    i18n.t(i18nKeys.startedSigningUpModal__resumeApplication__primaryAction),
}
